export function buildFileShareUrl(fileId) {
  const base = `${window.location.origin}${window.location.pathname}`;
  return `${base}#/everything?file=${encodeURIComponent(fileId)}`;
}
